export const TestOrigins = {
  apiOrigin: 'https://api.fakeswift.com',
  appOrigin: 'https://app.fakeswift.com',
} as const
